var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwinkle216(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "257.21013850795663 412.15715529380526 16.71986149204338 17.349619239823483",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M269.93,422.13c-.47.71-.99,1.95-1.9,2.75-1.08.96-2.51.71-3.72-.03-1.52-.93-2.5-2.29-2.98-4-.4-1.43.23-3.12,1.46-4.02,1.18-.87,3.04-.91,4.27-.04,1.64,1.16,2.46,2.82,2.87,5.34Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwinkle216);
export default __webpack_public_path__ + "static/media/twinkle-2-16.1df8530cc96c5133eaf7cb39e3372d47.svg";
export { ForwardRef as ReactComponent };